// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2arYL","productName":"Table_productName__3rSPl"};